<template>
	<div class="vx-col w-full mb-base" ref="popupContainer">
		<FilterCard
			:refreshKey="1"
			:filters="filtersTemplates"
			:showListLength="displayedProspectsSearches.length"
			@filter="handleFilterEmits($event)"
			:actions="actionsTemplates"
			@action="handleActionEmits($event)"
			:onChangeEmit="true"
			:subtext="`Resultat totale: ${displayProjects.length}`"
			:showProspectStatus="true"
		/>

		<vx-card style="max-height: 69vh; overflow: auto">
			<div ref="netlinkTable">
				<ProspectsTable
					:ps="displayProjects"
					@edit-prospect="editProspect($event)"
					@show-details="showDetails($event)"
					@delete-line="removeLine($event)"
				/>
			</div>
			<!-- @modify-ps="updateProspectSearch($event)"
					@display-societies="displayProspectsSearchesSocieties($event)"
					@display-netlinks="displayProspectsSearchesNetlinks($event)" -->
		</vx-card>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import FilterCard from "@/views/filters/FilterCard";
import ProspectsTable from "@/components/tables/ProspectsTable";
import Dns from "@/entities/Dns";
import store from "@/store/store";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
import AllLeadsTablePopup from "../../components/popups/AllLeadsTablePopup.vue";

export default {
	name: "ProspectsDashboardV2",
	components: {
		FilterCard,
		ProspectsTable,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			userIdFilter: "",
			searchNameFilter: "",
			activeFilter: false,
			activityDomainFilter: "",
			statusFilter: [],
			displayProjects: [],
			userIdFilterOn: false,
			searchNameFilterOn: false,
			activeFilterOn: false,
			activityDomainFilterOn: false,
			statusFilterOn: false,
			// dns: [],
			displayedProspectsSearchesFull: [],
			displayedProspectsSearches: [],
			modifiedDns: new Dns(Dns.getFormFields()),
			showDnsPopup: false,
			showSocietiesPopup: false,
			showNetlinksPopup: false,
			dnsSocieties: [],
			dnsNetlinks: [],
			configEndDatePicker: {
				// minDate: new Date(),
				dateFormat: "j/n/Y",
			},
			actionsTemplates: [
				{
					order: 1,
					emitSlugName: "new_prospect",
					buttonName: "Nouvelle Recherche de Prospects",
					buttonIcon: "icon-plus-circle",
					buttonColor: "primary",
				},
				{
					order: 2,
					emitSlugName: "lemlist_leads",
					buttonName: "Afficher les personnes contactées",
					buttonIcon: "icon-eye",
					buttonColor: "primary",
				},
			],
			filtersTemplates: [
				{
					order: 1,
					emitSlugName: "filter_name",
					filterPlaceHolder: "Nom de la recherche",
					value: "",
					type: "Input",
				},
				{
					order: 2,
					emitSlugName: "filter_domain",
					filterPlaceHolder: "Secteur d'activité",
					value: "",
					type: "Dropdown",
					params: {
						autocomplete: true,
						dropdownValues: [],
					},
				},
			],
		};
	},
	created() {
		this.getProspectsProjects();
		this.searchAndDisplay();
	},
	mounted() {
		// this.displayedProspectsSearchesFull = this.displayProspectsSearches(
		// 	this.ps
		// );
	},
	watch: {
		projects: function () {
			this.searchAndDisplay();
		},
		activityDomainFilter: function () {
			if (this.activityDomainFilter == "") {
				this.activityDomainFilterOn = false;
			} else {
				this.activityDomainFilterOn = true;
			}
			this.searchAndDisplay();
		},
		searchNameFilter: function () {
			if (this.searchNameFilter == "") {
				this.searchNameFilterOn = false;
			} else {
				this.searchNameFilterOn = true;
			}
			this.searchAndDisplay();
		},
		activeFilter: function () {
			this.activeFilterOn = true;
			this.searchAndDisplay();
		},
		userIdFilter: function () {
			if (this.userIdFilter == "") {
				this.userIdFilterOn = false;
			} else {
				this.userIdFilterOn = true;
			}
			this.searchAndDisplay();
		},
		statusFilter: function () {
			if (this.statusFilter == "") {
				this.statusFilterOn = false;
			} else {
				this.statusFilterOn = true;
			}
			this.searchAndDisplay();
		},
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		societies: () => {
			return store.state.societies;
		},
		projects: () => {
			return store.state.prospects_projects;
		},
		psActivityDomain: () => {
			let psActivity = [];
			for (let row of store.state.ps) {
				let foundDomainActivity = psActivity.findIndex(
					(activityRow) => activityRow.name == row.domain_activity
				);
				if (foundDomainActivity < 0) {
					psActivity.push({
						name: row.domain_activity,
						id: row.domain_activity,
					});
				}
			}
			this.filtersTemplates[1].params.dropdownValues = psActivity;
			return psActivity;
		},
	},
	methods: {
		displayAllLeadsPopup() {
			this.showNotesPopup = true;
			let ComponentClass = Vue.extend(AllLeadsTablePopup);

			let notesPopup = new ComponentClass({
				propsData: {
					popupActive: true,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			notesPopup.$mount();
			this.$refs.popupContainer.appendChild(notesPopup.$el);
		},
		removeLine(onePs) {
			const index = this.displayProjects.findIndex(
				(row) => row.id === onePs.id
			);

			// If the item is found, remove it from the array
			if (index !== -1) {
				this.displayProjects.splice(index, 1);
			}
		},
		showDetails(ps) {
			this.$router.push({
				name: "prospectsProjectDetails",
				params: { ppId: ps.id },
			});
		},
		// editProspect(ps) {
		// 	this.$router.push({
		// 		name: "prospectsProjectDetails",
		// 		params: { ppId: ps.id },
		// 	});
		// },
		editProspect(ps) {
			this.$router.push({
				name: "update_entity",
				params: { psId: ps.id, isEdit: true, updateEntityForm: "prospect" },
			});
		},
		getProspectsProjects() {
			this.$store.dispatch("getProspectsProjects", this.activeUser.id);
		},

		getSocietyName(society_id) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == society_id);
			society_name = society.name;
			return society_name;
		},

		/**
		 * @method handleFilterEmits Receives filter emits and assign filters accordingly
		 * @param {Array} receivedEmit First cell is the filter's slug, second cell is the filter value
		 */
		handleFilterEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			let templateRowIndex = this.filtersTemplates.findIndex(
				(row) => row.emitSlugName == receivedEmit[0]
			);
			if (templateRowIndex >= 0)
				this.filtersTemplates[templateRowIndex].value = receivedEmit[1].value;
			switch (receivedEmit[0]) {
				case "filter_name":
					this.searchNameFilter = receivedEmit[1].value;
					break;
				case "filter_domain":
					this.activityDomainFilter = receivedEmit[1].value;
					break;
				default:
					break;
			}
			/*
			 * Find filter value
			 * switch(receivedEmit[0]){
			 * 	case "filter"
			 * }
			 */
		},
		searchAndDisplay() {
			let tempList = [...this.projects];
			if (this.searchNameFilterOn)
				tempList = tempList.filter((row) =>
					row.name.includes(this.searchNameFilter)
				);
			this.displayProjects = tempList;
		},

		/**
		 * @method handleActionEmits Receives action emits and assign actions accordingly
		 * @param {Array} receivedEmit First cell is the action's slug
		 */
		handleActionEmits(receivedEmit) {
			//console.log(receivedEmit);
			// Find template value
			switch (receivedEmit[0]) {
				case "new_prospect":
					// <vs-button icon-pack="feather" icon="icon-plus-circle" color="primary" @click="$router.push({ name: 'new_entity' })">Nouveau contrat</vs-button>
					this.$router.push({
						name: "new_entity",
						params: { newEntityForm: "prospect" },
					});
					break;
				case "lemlist_leads":
					this.displayAllLeadsPopup();
					break;

				default:
					break;
			}
		},
	},
};
</script>
